module.exports = __webpack_public_path__ + "static/media/splash-quote.ae635de8.mp4";